import * as React from "react";
import Img from "gatsby-image";

import { ContentfulBlock } from "../../graphql-types";
import Block from "./block";
import { Container } from "./style";

interface Props {
  blocks: ContentfulBlock[];
}

export default function ContentBlocks({ blocks }: Props) {
  return (
    <Container>
      {blocks.map(block => (
        <Block block={block} key={block.id} />
      ))}
    </Container>
  );
}
